function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgR = function SvgR(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 2",
    viewBox: "0 0 170.51 170.51"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M130.82 42.81H42.44v84.89h18.2v-14.71L75.5 98.13l29.57 29.57h25.75L88.38 85.25zM60.65 87.24V61.01h26.23z",
    "data-name": "Layer 1-2",
    style: {
      fill: "currentColor"
    }
  }));
};
export default SvgR;